import socket from '@/services/socket.js'

export default {
  /**
   * Get user license by group id.
   *
   * @param group_id
   * @returns Promise
   */
  getUserLicense(group_id) {
    let action = '/license/get'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        if (data && data.licenses && data.licenses.length) {
          resolve(data.licenses[0])
        } else {
          resolve({
            license_type: 'free',
            status: 'expired'
          })
        }
      })
    })
  }
}